module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/common/ordering/ordering.component.sass
// module id = ./src/app/common/ordering/ordering.component.sass
// module chunks = main